const TOKEN_KEY = "ag_auth_token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {}
}

export function clearToken() {
  setToken(null);
}

/**
 * Thin fetch wrapper. Routes all traffic through our backend prefix `/api`.
 * - Injects Authorization: Bearer <token> if present.
 * - Serializes JSON body automatically unless it's already a string/FormData.
 * - Returns parsed JSON or throws ApiError.
 */
export async function apiFetch(path, { method = "GET", body, headers, signal } = {}) {
  const token = getToken();
  const h = { Accept: "application/json", ...(headers || {}) };
  if (token) h["Authorization"] = `Bearer ${token}`;

  let payload = body;
  if (body !== undefined && body !== null && !(body instanceof FormData) && typeof body !== "string") {
    h["Content-Type"] = h["Content-Type"] || "application/json";
    payload = JSON.stringify(body);
  }

  const apiBase = (import.meta.env.VITE_API_BASE || "/api").replace(/\/$/, "");
  const url = path.startsWith("/") ? path : `/${path}`;
  const res = await fetch(`${apiBase}${url}`, {
    method,
    headers: h,
    body: method === "GET" || method === "HEAD" ? undefined : payload,
    signal,
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = text;
    }
  }

  if (!res.ok) {
    const err = new ApiError(
      (data && typeof data === "object" && (data.error || data.message)) ||
        `HTTP ${res.status}`,
      res.status,
      data
    );
    throw err;
  }

  return data;
}

export class ApiError extends Error {
  constructor(message, status, payload) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.payload = payload;
  }
}
